import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { Link, withRouter } from "react-router-dom";
import Loader from "../../../Components/MainLayout/Loader";
import Header from "../../../Components/MainLayout/Header";
import Authorize from "../../../../global/Authorize";

const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});

class Group extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Complaint: [],
      roles: [],
      checkedroles: [],
      formData: {
        school: "",
        name: "",
        phone_no: "",
        complain: "",
      },
      loading: false,
      success: false,
      alertMessage: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = "Group Sms";
    this.fetchroles();
  }

  fetchroles = () => {
    this.setState({ loading: true });
    axios.get(`/api/roles`, {}).then((res) => {
      this.setState({
        loading: false,
        roles: res.data,
      });
    });
  };

  handleClick = () => {
    this.setState({ loading: true });
  };

  handleCheckbox = (event) => {
    var arr = this.state.checkedroles;
    if (this.state.checkedroles.includes(event.target.value)) {
    } else {
      arr.push(event.target.value);
    }
    this.setState({ checkedroles: arr });
  };

  handleChange = (event) => {
    const { formData } = this.state;
    formData[event.target.name] = event.target.value;
    this.setState({ formData });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    let form_data = new FormData();
    const { formData } = this.state;
    // var
    form_data.append("school", this.props.user.user.school.id);
    form_data.append("message", formData.message);
    for (var i = 0; i < this.state.checkedroles.length; i++) {
      form_data.append("roles", this.state.checkedroles[i]);
    }
    // form_data.append("roles", JSON.stringify(this.state.checkedroles))
    if (this.state.formData.message) {
      axios
        .post(`/api/gsendSMS`, form_data)
        .then((response) => {
          this.setState({ loading: false, success: true });
        })
        .catch((error) => {
          this.setState({ loading: false });
        });
    } else {
      this.setState({ loading: false, alertMessage: true });
    }
  };

  render() {
    console.log(this.props.user);

    const { formData } = this.state;
    const rolesdata = this.state.roles?.map((item) => {
      var role = item.name.split("_");
      return (
        <div className="input-group in-line align-items-center pb-3">
          <input
            type="checkbox"
            onChange={this.handleCheckbox}
            name="checkecollectfee"
            color="primary"
            value={item.id}
          />
          <div className="th-12 th-cap pl-2">{role[1]}</div>
        </div>
      );
    });
    return (
      <Authorize
        roles={["IS_ADMIN", "IS_SUPERADMIN", "IS_PRINCIPAL"]}
        redirect
        to="/login"
      >
        <div>
          <Header to="/home" title="Group SMS" />

          <div className="d-flex flex-row th-no-scroll pt-2">
            <div className="pl-3 pr-4 text-center th-cap th-14 py-2">
              <div className="th-primary">Group SMS</div>
              <hr
                className="w-100 my-1 th-border"
                style={{ borderWidth: 5, borderRadius: 5 }}
              />
            </div>

            <Link style={{ textDecoration: "none" }} to="/classsms">
              <div className="pl-3 pr-4 text-center th-cap th-14 py-2">
                <div className="th-black">Class SMS</div>
              </div>
            </Link>
          </div>

          <div className="container">
            <div className="rounded">
              <form onSubmit={this.handleSubmit} autoComplete="off">
                <div className="input-group input-group shadow-sm">
                  <textarea
                    className="form-control th-input-primary"
                    placeholder="Message"
                    style={{ minHeight: 200 }}
                    name="message"
                    value={formData.message}
                    onChange={this.handleChange}
                  />
                </div>
                <div className="th-14 th-medium th-black mt-3 mb-2">
                  Send To:
                </div>
                {rolesdata}
                {this.state.success && (
                  <div className="th-14 th-medium th-black mt-3 mb-2 text-center">
                    Message Send Successfully
                  </div>
                )}
                {this.state.alertMessage && (
                  <div className="th-14 th-medium th-black mt-3 mb-2 text-center">
                    Message Not Send Successfully
                  </div>
                )}
                <div className="d-flex justify-content-end py-3">
                  {this.state.loading ? (
                    <div className="my-1 pr-2">
                      <Loader />
                    </div>
                  ) : null}
                  <button
                    onClick={this.handleClick}
                    type="submit"
                    className="th-btn-primary px-4 py-2"
                  >
                    SUBMIT
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </Authorize>
    );
  }
}
export default withRouter(connect(mapStateToProps)(Group));
